<template>
    <v-container fluid>
        <v-card>
            <v-toolbar color="secondary" flat dense>
                <v-toolbar-title>Stock By Categories</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
                <v-row>
                    <v-col cols="12" xs="12" md="4">
                        <v-autocomplete name="checkCategoryStockStore" dense outlined v-model="queryStore"
                            :items="stores" label="Select Branch / Shop" item-text="Name"
                            item-value="id"></v-autocomplete>
                    </v-col>

                    <v-col cols="12" xs="12" md="4">
                        <v-autocomplete name="stockCategoryName" dense outlined v-model="categoryId" :items="categories"
                            label="Select Category" item-text="Name" item-value="id"></v-autocomplete>
                    </v-col>

                    <v-col cols="12" xs="12" md="4">
                        <v-btn class="primary" :loading="loader" @click="queryData">Generate Report</v-btn>
                    </v-col>
                </v-row>

                <v-divider></v-divider>

                <v-row dense class="mt-2">
                    <v-col cols="12" xs="12" md="12">
                        <v-row>

                            <v-col cols="12" md="1">
                                <!-- excel icon -->
                                <download-excel :data="inventory" :fields="fields" name="Stock List">
                                    <v-icon color="green">mdi-file-excel</v-icon>
                                </download-excel>
                                <!-- end -->
                            </v-col>

                            <v-col cols="4">
                                <v-btn v-if="inventory.length > 0" color="accent" @click="printStockViaThermal" text>
                                    <v-icon left>mdi-printer</v-icon>Print Stock Via Thermal
                                </v-btn>
                            </v-col>

                            <v-col cols="12" style="margin-top: -20px">
                                <!-- start of table -->
                                <v-data-table :loading="loader" loading-text="Loading Data......" :headers="headers"
                                    :items="inventory" :items-per-page="2000">
                                    <!-- <template v-slot:item.Name="{ item }">
                                        <v-btn color="primary" text :to="`/quick-audit/${item.productId}`">{{
                                            item.Name }}</v-btn>
                                    </template> -->

                                    <template v-slot:item.AvailableQty="{ item }">
                                        <span>{{ item.purchaseUomQty }}</span>
                                    </template>

                                    <template v-slot:item.PurchaseUnit="{ item }">
                                        <span v-if="item.HasUom == 1 && item.BaseStockActive == 'N'">{{
                                            item.PurchaseUnit }}</span>
                                    </template>

                                    <template v-slot:item.BaseUnitStock="{ item }">
                                        <span v-if="item.HasUom == 1 && item.BaseStockActive == 'N'">{{
                                            item.BaseUnitStock }}</span>
                                    </template>

                                    <template v-slot:item.BaseUnit="{ item }">
                                        <span v-if="item.HasUom == 1 && item.BaseStockActive == 'N'">{{ item.BaseUnit
                                        }}</span>
                                    </template>

                                </v-data-table>
                                <!-- end -->
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-text>
            <!-- snackbar -->

            <snackbar ref="snackbar"></snackbar>
        </v-card>
    </v-container>
</template>


<script>
export default {
    computed: {
        activeStore() {
            return localStorage.getItem("store_id");
        },
    },
    data() {
        return {
            selectedStoreName: "",
            showPrinterDiv: false,
            DefaultDistributorCustomer: 0,
            smsRef: "",
            select: "",
            isLoading: false,
            categoryId: null,
            search: null,
            searchStock: null,
            pageItems: 500,
            loader: false,
            editItem: {},
            damagedItem: {},
            transferItem: {},
            store: null,
            queryStore: null,
            stores: [],
            categories: [],
            users: [],
            date: null,
            dialog: false,
            damageDialog: false,
            transferDialog: false,
            searchProducts: null,
            todayDate: new Date().toISOString().substr(0, 10),
            products: [],
            headers: [
                { text: "Product Name", value: "Name" },
                { text: "Available Qty", value: "AvailableQty" },
                // { text: "Purchase Unit", value: "purchaseUomQty" },
                { text: "Purchase Uom", value: "PurchaseUnit" },
                { text: "Base Unit Stock", value: "BaseUnitStock" },
                { text: "Base Unit", value: "BaseUnit" },
                // { text: "Remainder", value: "remainder" },
            ],
            fields: {
                Product: "Name",
                AvailableQty: "AvailableQty",
            },
            inventory: [],
        };
    },
    watch: {
        searchProducts(val) {
            if (val && val !== this.select && this.querySelections(val)) {
                this.querySelections(val);
            }
        },
    },
    methods: {
        queryData() {
            const id = this.queryStore;
            var categoryId = this.categoryId;
            if (id == null || id == "" || id == undefined) {
                this.$refs.snackbar.show("Please select a branch / shop", "red");
                return;
            }

            if (categoryId == null || categoryId == "" || categoryId == undefined) {
                this.$refs.snackbar.show("Please select a category", "red");
                return;
            }

            const self = this;
            self.loader = true;
            this.$store
                .dispatch("get", `/stock-by-category/${id}/${categoryId}`)
                .then((res) => {
                    if (res.ResultCode == 1200) {
                        self.loader = false;
                        if (res.ResponseData != null) {
                            self.inventory = res.ResponseData;
                        }

                    } else {
                        self.loader = false;
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch((err) => {
                    self.loader = false;
                    this.$refs.snackbar.show(err, "red");
                });
        },
        getStores() {
            const self = this;
            this.$store
                .dispatch("get", `/stores`)
                .then((res) => {
                    if (res.ResultCode == 1200) {
                        self.stores = res.ResponseData;
                    } else {
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch((err) => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
        getCategories() {
            const self = this;
            this.$store
                .dispatch("get", `/products-categories`)
                .then((res) => {
                    if (res.ResultCode == 1200) {
                        self.categories = res.ResponseData;
                    } else {
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch((err) => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
    },
    created() {
        Promise.all([this.getStores(), this.getCategories()]);
    },
};
</script>

<style lang="scss" scoped></style>